export default "__VITE_ASSET__B21h3bQr__"